import * as React from "react";
import {useEffect, useState} from "react";
import "./free-apartments.css";
import {ErlButtonBig} from "../ErlButtonBig";
import {AppContext} from "../../context/AppContext";
import {LoaderSpinner} from "../LoaderSpinner";
import {ApiResponse} from "../../../shared/models/ApiResponse";

interface FreeApartmentsProps {
    houseId: number,
    lang: string,
    baseUrl: string,
}

export default function FreeApartments(props: FreeApartmentsProps) {

    const [apartmentsCount, setApartmentsCount] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [isBookable, setIsBookable] = useState<boolean>(true);
    const [apartmentNextAvailableFrom, setApartmentNextAvailableFrom] = useState<Date>(new Date());
    const [apartmentsInstantlyAvailable, setApartmentsInstantlyAvailable] = useState<boolean>(false);
    const [isApartment, setIsApartment] = useState<boolean>(false);

    const AVAILABILITY_NOW = 0;
    const AVAILABILITY_STATUS_WITHIN_6_MONTH = 1;

    interface translations {
        freeApartmentsAvailable: string,
        freeApartmentAvailable: string,
        freeFlatsAvailable: string,
        freeFlatAvailable: string,
        freeApartments: string,
        freeApartment: string,
        freeFlats: string,
        freeFlat: string,
        rentNow: string,
        notBookable: string,
        notBookableApartments: string,
        from: string,
        NoApartmentsAvailable: string,
        NoFlatsAvailable: string,
    }

    const de: translations = {
        'freeApartmentsAvailable': 'Freie Appartements verfügbar',
        'freeApartmentAvailable': 'Freies Appartement verfügbar',
        'freeFlatsAvailable': 'Freie Wohnungen verfügbar',
        'freeFlatAvailable': 'Freie Wohnung verfügbar',
        'freeApartments': 'Appartements verfügbar',
        'freeApartment': 'Appartement verfügbar',
        'freeFlats': 'Wohnungen verfügbar',
        'freeFlat': 'Wohnung verfügbar',
        'rentNow': 'Informieren und reservieren',
        'notBookable': 'Informieren und anfragen',
        'notBookableApartments': 'Appartements',
        'from': 'ab',
        'NoApartmentsAvailable': 'Keine Appartements verfügbar',
        'NoFlatsAvailable': 'Keine Wohnungen verfügbar',
    }

    const en: translations = {
        'freeApartmentsAvailable': 'Free Apartments Available',
        'freeApartmentAvailable': 'Free Apartment Available',
        'freeFlatsAvailable': 'Free Flats Available',
        'freeFlatAvailable': 'Free Flat Available',
        'freeApartments': 'Apartments available',
        'freeApartment': 'Apartment available',
        'freeFlats': 'Flats available',
        'freeFlat': 'Flat available',
        'rentNow': 'Information and reservations',
        'notBookable': 'Information and inquiries',
        'notBookableApartments': 'Apartments',
        'from': 'from',
        'NoApartmentsAvailable': 'No Apartments Available',
        'NoFlatsAvailable': 'No Flats Available',
    }

    const [translations, setTranslations] = useState<translations>(de);

    useEffect(() => {

        if (props.lang == 'EN') {
            setTranslations(en);
        }

        AppContext.onOfficeService.getFreeApartments(props.houseId).then((apiResponse: ApiResponse) => {
            setApartmentsCount(apiResponse.response.apartmentsAvailable ?
                apiResponse.response.apartmentsAvailable[AVAILABILITY_NOW] + apiResponse.response.apartmentsAvailable[AVAILABILITY_STATUS_WITHIN_6_MONTH] : 0);
            setIsBookable(apiResponse.response.isBookable);
            setLoading(false);
            setApartmentNextAvailableFrom(new Date(apiResponse.response.apartmentNextAvailableFrom));
            setApartmentsInstantlyAvailable(apiResponse.response.apartmentsAvailable[AVAILABILITY_NOW] > 0);
            setIsApartment(apiResponse.response.isApartment);

        }).catch(reason => {
            setLoading(false);
        });
    }, []);

    const getText = () => {
        if(!isBookable || apartmentsCount == 0) {
            return isApartment ? translations.NoApartmentsAvailable : translations.NoFlatsAvailable;
        }

        if (apartmentsInstantlyAvailable) {
            return isApartment ?
                apartmentsCount == 1 ? translations.freeApartmentAvailable : translations.freeApartmentsAvailable
                :
                apartmentsCount == 1 ? translations.freeFlatAvailable : translations.freeFlatsAvailable;
        }

        return isApartment ?
            apartmentsCount == 1 ? translations.freeApartment : translations.freeApartments
            :
            apartmentsCount == 1 ? translations.freeFlat : translations.freeFlats
            + ' ' + translations.from + ' ' +
            new Intl.DateTimeFormat(
                (props.lang == 'EN' ? 'en-US' : 'de-DE'), {day: '2-digit', month: '2-digit', year: 'numeric'})
                .format(apartmentNextAvailableFrom);
    }

    return <div className={"free-apartments"}>
        {loading ? (
            <LoaderSpinner/>
        ) : (
            <>
                <div className={"counter"}>{apartmentsCount}</div>
                <p>
                    {   // Gleiche Ausgabe wie react-portals/rental-portal/src/models/HouseHelper.ts
                        getText()
                    }
                </p>
                <div className={"spacer-10"}/>
                <div>
                    <ErlButtonBig label={isBookable && apartmentsCount > 0 ? translations.rentNow : translations.notBookable} onclick={() => {
                        window.open(props.baseUrl + '/rent/house/' + props.houseId + '/overview', '_self');
                    }}>
                    </ErlButtonBig>
                </div>
            </>
        )}

    </div>;
}
